module.exports = __webpack_public_path__ + "static/media/tipo_de_usuarios.ff67f5e2.svg";